export default __webpack_public_path__ + "static/media/logo_CircularTool.c942398b.png";